import { Avatar, Flex, SlideoutDrawerV2, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import * as styles from "../styles_vanilla.css";

type ReviewData = {
  reviewerName: string;
  reviewedAt: string;
  deniedReason: string;
};

type DeniedReasonDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  review: ReviewData | null;
};

export const DeniedReasonDrawer = ({ isOpen, onClose, review }: DeniedReasonDrawerProps) => (
  <SlideoutDrawerV2 isOpen={isOpen} onClose={onClose}>
    <SlideoutDrawerV2.ComplexHeader title="Reason" description="Denial reason details" />
    <SlideoutDrawerV2.Body>
      {review && (
        <Flex gap={SPACING.SMALL} alignItems="flex-start">
          <Avatar
            name={review.reviewerName}
            size="sm"
            backgroundColor={Colors.Primary600}
            color={Colors.Neutral0}
          />
          <Flex
            flexDirection="column"
            gap={SPACING.X_SMALL}
            className={styles.deniedReasonContainer}
          >
            <Flex gap={10} alignItems="center">
              <Text variant="strong-md">{review.reviewerName}</Text>
              <Text variant="secondary-md">{review.reviewedAt}</Text>
            </Flex>
            <Text variant="regular-md">{review.deniedReason}</Text>
          </Flex>
        </Flex>
      )}
    </SlideoutDrawerV2.Body>
  </SlideoutDrawerV2>
);
